var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-block impact-module"},[_c('div',{staticClass:"inner"},[(_vm.data.has_border)?_c('div',{staticClass:"border"}):_vm._e(),_c('div',{staticClass:"text-content",domProps:{"innerHTML":_vm._s(_vm.data.text_content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }